<template>
  <div>
    <van-popup
      v-model="visible"
      position="center"
      :style="{ height: 'auto', width: '90%' }"
    >
      <van-nav-bar title="需要服務 Call Service" fixed placeholder />

      <van-grid clickable :border="false" column-num="2">
        <van-grid-item v-for="r in getBellType()" :key="r" @click="callService(r)">
          <div class="C2" style="line-height: 3rem; font-size: 1rem">{{ r }}</div>
          <!-- <div class="tip">Water</div> -->
        </van-grid-item>
        <!-- <van-grid-item @click="callService('餐具')">
          <div class="C2">餐具</div>
          <div class="tip">Tableware</div>
        </van-grid-item>
        <van-grid-item @click="callService('茶水')">
          <div class="C2">茶水</div>
          <div class="tip">Water</div>
        </van-grid-item>
        <van-grid-item @click="callService('上甜點')">
          <div class="C2">上甜點</div>
          <div class="tip">Dessert</div>
        </van-grid-item>
        <van-grid-item @click="callService('打包')">
          <div class="C2">打包</div>
          <div class="tip">Pack</div>
        </van-grid-item>
        <van-grid-item @click="callService('結帳')">
          <div class="C2">結帳</div>
          <div class="tip">Check</div>
        </van-grid-item>
        <van-grid-item @click="callService('其它')">
          <div class="C2">其它</div>
          <div class="tip">Other</div>
        </van-grid-item> -->
      </van-grid>
    </van-popup>
  </div>
</template>
<style scoped>
.tip {
  font-size: 0.8rem;
  color: grey;
  line-height: 1.5rem;
}
</style>
<script>
export default {
  data() {
    return {
      visible: false,
    };
  },
  methods: {
    show() {
      this.visible = true;
    },
    async callService(type) {
      try {
        var tblid = this.$route.query.tblid;
        var body = { tblid: tblid, type: type };
        var res = await this.apiCallService(body);
        // this.$refs.rSure.show("bell");
        this.visible = false;
        this.gMsgbox("您的需求已傳送");
        console.log(res);
      } catch (error) {
        console.log(error);
      }
    },
    getBellType() {
      try {
        let text = this.sGetConfig("bellType");
        if (text == "") return ["餐具", "茶水", "上甜點", "打包", "結帳", "其它"];
        let array = text.split(",");
        console.log("getBellType", array);
        return array;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
